var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    fill: "#6A7590",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.66 5.932h9.226a.633.633 0 00.464-.196.634.634 0 00.196-.463.634.634 0 00-.196-.464L5.736.196A.634.634 0 005.273 0a.634.634 0 00-.464.196L.196 4.809A.633.633 0 000 5.273c0 .178.065.333.196.463.13.13.285.196.463.196z"
  })));
}
export default __webpack_public_path__ + "static/chevronUp.e1db422f.svg";
export { SvgChevronUp as ReactComponent };